import { useCallback } from 'react';
import { useToast } from '../context/ToastContext';

export const usePopupMessage = () => {
  const { showToast } = useToast();

  return {
    setError: useCallback((message) => {
      if (message) showToast(message, 'error');
    }, [showToast]),
    setStatus: useCallback((message) => {
      if (message) showToast(message, 'success');
    }, [showToast]),
    setWarning: useCallback((message) => {
      if (message) showToast(message, 'warning');
    }, [showToast]),
    setInfo: useCallback((message) => {
      if (message) showToast(message, 'info');
    }, [showToast]),
    clearError: useCallback(() => {}, []),
    clearStatus: useCallback(() => {}, []),
  };
};
